<template>
    <!-- NB: this content should never actually show... -->
    <div/>
</template>

<script>

import Vue from 'vue'

/**
 * Page for equipment owner to create a (requested) Exemption
 */
export default Vue.extend({
    name: 'ExemptionCreate',
    props: {
        equipmentId: Number
    },
    async mounted () {
        const response = await this.$api.createItem(this, 'exemption', {
            equipment_id: this.equipmentId,
            status: 'DRAFT'
        })
        const exemptionId = response.body.id
        this.$router.replace(`/exemption/edit/${exemptionId}`)
    },
})

</script>

